import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { VendorService } from '../proxy/controlling/controllers/vendor.service';
import { LocationService } from '@planning/proxy/planning/controllers/location.service';

FieldBuilder.setNamespace('Controlling');

export const VENDORCONSTRAINTSPERREGION_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .checkbox('applyDose', 'Entity.VendorConstraintsPerRegion.ApplyDose')
    .build(),
  FieldBuilder
    .checkbox('applyAps', 'Entity.VendorConstraintsPerRegion.ApplyAps')
    .build(),
  FieldBuilder
    .checkbox('applySpecialCoefficient', 'Entity.VendorConstraintsPerRegion.ApplySpecialCoefficient')
    .build(),
  FieldBuilder
    .checkbox('applyDosesApprovalInBioforest', 'Entity.VendorConstraintsPerRegion.ApplyDosesApprovalInBioforest')
    .build(),
  FieldBuilder.foreignKey(
    'vendorId',
    'Entity.Vendor',
    VendorService
  )
    .required()
    .displayFromNested('vendor.fantasyName')
    .sortBy('vendor.fantasyName')
    .hideInChildForms()
    .build(),
  FieldBuilder
    .foreignKey('regionLocationId', 'Entity.VendorConstraintsPerRegion.RegionLocation', LocationService)
    .queryFilter({ locationTypeEntityName: 'Region' })
    .required()
    .display('name')
    .keyField('id')
    .build(),
];

export const VENDORCONSTRAINTSPERREGION_CONFIG = {
  entityName: 'VendorConstraintsPerRegion',
  localizationKey: 'Controlling::Entity.VendorConstraintsPerRegion',
  fields: VENDORCONSTRAINTSPERREGION_FIELDS,
  permission: 'ControllingContract.VendorConstraintsPerRegions',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
